import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import type { EMessageChannel } from 'src/services/api';
import { LeadMessagesModeContext } from 'src/pages/landlord/leads/messages/context/mode/context';
import { getConversationPath } from 'src/pages/landlord/leads/messages/context/mode/get-conversation-path';
import { getBackLabelFromPath } from 'src/pages/landlord/leads/messages/components/hotkeys/LeadMessagesHotkeys';

export const CONVERSATIONS_INDEX_PATH = '/landlord/inner/root';

type Props = {
    children: React.ReactNode;
};

export default function PageLeadMessagesModeProvider({ children }: Props) {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const backHref = searchParams.get('back_path') || CONVERSATIONS_INDEX_PATH;
    const backLabel = getBackLabelFromPath(backHref);
    const escHotkeyLabel = 'Back to ' + backLabel;

    const close = () => {
        navigate(backHref);
    };

    const goToConversation = (leadUuid: string, channel: EMessageChannel) => {
        const backPath = searchParams.get('back_path') ?? undefined;
        const path = getConversationPath(channel, leadUuid, backPath);
        if (path) {
            navigate(path);
        }
    };

    return (
        <LeadMessagesModeContext.Provider value={{
            variant: 'page',
            goToConversation,
            close,
            backLabel,
            escHotkeyLabel,
            backHref,
        }}
        >
            {children}
        </LeadMessagesModeContext.Provider>
    );
}
